import React, { Component } from 'react';
import Nav from '../components/Nav';
import GetTheApp from '../components/GetTheApp';
import Footer from '../components/Footer';

import FaqsData from '../faqs.json';

class Faq extends Component {

  constructor(props) {
    super(props);

    this.renderAnswer = this.renderAnswer.bind(this);
  }

  createMarkup(answer) {
    return {__html: answer};
  }

  renderAnswer(title, answer, index) {
    return(
      <div className="row space-4" key={index}>
        <div className="col-sm-12">
          <h3 className="space-2">{title}</h3>
          <p dangerouslySetInnerHTML={this.createMarkup(answer)}></p>
        </div>
      </div>
    );
  }

  render() {

    const faqs = FaqsData.faqs;

    return (
      <div className="Faq">
        <div className="background-blue clearfix">
          <Nav />
        </div>

        <div className="page-container-responsive">
          <div className="row space-top-5 space-4 space-top-sm-4">
            <div className="col-sm-12 col-md-12">
              <h2>Answers for your questions.</h2>
            </div>
          </div>

          {faqs.map((faq, index) => {
            return(
              this.renderAnswer(faq.title, faq.answer, index)
            )
          })}
        </div>

        <GetTheApp />
        <Footer />
      </div>
    );
  }
}

export default Faq;



/** WEBPACK FOOTER **
 ** ./src/pages/Faq.js
 **/